import { Icon } from '@iconify/react';

import SvgIcon from '@mui/material/SvgIcon';

import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';



import { ReactComponent as HomeIcon } from "../../../public/static/dashboard/home.svg";
import { ReactComponent as UserIcon } from "../../../public/static/dashboard/users.svg";
import { ReactComponent as LiveVisitsIcons } from "../../../public/static/dashboard/livevisits.svg";
import { ReactComponent as PreviousVisitsIcon } from "../../../public/static/dashboard/previousvisits.svg";
import { ReactComponent as SessionIcon } from "../../../public/static/dashboard/sessions.svg";
import { ReactComponent as DevicesIcon } from "../../../public/static/dashboard/devices.svg";
import { ReactComponent as ControlCenterIcon } from "../../../public/static/dashboard/controlcenter.svg";
import { ReactComponent as CustomerListIcon } from "../../../public/static/dashboard/customerlist.svg";


// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  // {
  //   title: 'home',
  //   path: '/dashboard/app',
  //   icon: <HomeIcon/>,
  //   env: ["development", "sandbox", "production"]
  // },
  // {
  //   title: 'Home',
  //   path: '/dashboard/smartlock',
  //   icon: <HomeIcon/>,
  //   env: ["development", "sandbox", "production"]
  // },


  {
    title: 'Dashboard',
    path: '/dashboard/soundboxT',
    icon: <HomeIcon/>,
    accessRole:["superadmin","admin","checker","maker","support_1","support_2"],
    env: ["development", "sandbox", "production"]
  },

 
 
  // {
  //   title: 'FOS ',
  //   path: '/dashboard/user',
  //   icon: <UserIcon/>,
  //   env: ["development", "sandbox", "production"]
  // },

  // {
  //   title: 'Customer Visits',
  //   path: '/dashboard/visits',
  //   icon: <CustomerListIcon/>,
  //   env: ["development", "sandbox", "production"],
   
  // },
 

 
  // {
  //   title: 'Session',
  //   path: '/dashboard/myvideocalls',
  //   icon: <SessionIcon/>,
  //   env: ["development", "sandbox", "production"]
  // },

  

  // {
  //   title: 'Routes',
  //   path: '/dashboard/routes',
  //   icon: <RouteIcon/>,
  //   env: ["development", "sandbox", "production"]
  // },
  // {
  //   title: 'Trips',
  //   path: '/dashboard/trips',
  //   icon: <ModeOfTravelIcon/>,
  //   env: ["development", "sandbox", "production"]
  // },

  // {
  //   title: 'Vehicles',
  //   path: '/dashboard/vehicle',
  //   icon: <RouteIcon/>,
  //   env: ["development", "sandbox", "production"]
  // },

  {
    title: 'Devices',
    path: '/dashboard/soundboxdevices',
    icon: <DevicesIcon />,
    accessRole:["superadmin"],
    env: ["development", "sandbox", "production",]
  },

  {
    title: 'Organizations',
    path: '/dashboard/organizations',
    icon: <ApartmentRoundedIcon />,
    accessRole:["superadmin"],
    env: ["development", "sandbox", "production"]
  },

  {
    title: 'Merchants',
    path: '/dashboard/merchants',
    icon: <StoreOutlinedIcon />,
    accessRole:["admin","checker","maker","support_1","support_2"],
    env: ["development", "sandbox", "production"]
  },

  {
    title: 'User',
    path: '/dashboard/organizationusers',
    icon: <UserIcon />,
    accessRole:["admin","checker"],
    env: ["development", "sandbox", "production"]
  },


  
  
  {
    title: 'Control Center',
    path: '/dashboard/soundboxcontrolcenter',
    icon: <ControlCenterIcon />,
    accessRole:["superadmin","admin"],
    env: ["development", "sandbox", "production"]
  },
  // {
  //   title: 'Sensor History',
  //   path: '/dashboard/sensorhistory',
  //   icon: <DeviceHubOutlinedIcon />,
  //   env: ["development", "sandbox", "production"],
  //   children: [
  //     {
  //       title: 'All Sensor',
  //       path: '/dashboard/sensorhistory',
  //       icon: <DeviceHubOutlinedIcon />,
  //       state:{sensorType:''}
  //     },
  //     {
  //       title: 'Light Sensor',
  //       path: '/dashboard/lightsensorhistory',
  //       icon: <DeviceHubOutlinedIcon />,
  //       state:{sensorType:'AMBIENT_LIGHT'}
  //     },
  //     {
  //       title: 'Pressure Sensor',
  //       path: '/dashboard/pressuresensorhistory',
  //       icon: <DeviceHubOutlinedIcon />,
  //       state:{sensorType:'PRESSURE'}
  //     },
  //     {
  //       title: 'Humidity Sensor',
  //       path: '/dashboard/humiditysensorhistory',
  //       icon: <DeviceHubOutlinedIcon />,
  //       state:{sensorType:'HUMIDITY'}
  //     },
  //     {
  //       title: 'Body Temp Sensor',
  //       path: '/dashboard/bodytempsensorhistory',
  //       icon: <DeviceHubOutlinedIcon />,
  //       state:{sensorType:'TEMPERATURE_SUBJECT'}
  //     },
  //     {
  //       title: 'Env Temp Sensor',
  //       path: '/dashboard/envtempsensorhistory',
  //       icon: <DeviceHubOutlinedIcon />,
  //       state:{sensorType:'TEMPERATURE_ENVIRONMENT'}
  //     }
  //   ]
  // },
  // {
  //   title: 'Orders',
  //   path: '/dashboard/pwarehouseorders',
  //   icon: <RecordVoiceOverIcon />,
  //   env: ["development"]
  // },
  // {
  //   title: 'My Calls',
  //   path: '/dashboard/myvideocalls',
  //   icon: <RecordVoiceOverIcon />,
  //   env: []
  // },
  // {
  //   title: 'Election Commission',
  //   path: '/404',
  //   icon: <AccountBalanceIcon />,
  //   env: ["development",]
  // },
  // {
  //   title: 'Mining Module',
  //   path: '/404',
  //   icon: getIcon(peopleFill),
  //   env: ["development"]
  // },
  // {
  //   title: 'Live Streaming ',
  //   path: '/dashboard/livestreaming',
  //   icon: getIcon(peopleFill)
  // },
  // {
  //   title: 'product',
  //   path: '/dashboard/products',
  //   icon: getIcon(shoppingBagFill)
  // },
  // {
  //   title: 'blog',
  //   path: '/dashboard/blog',
  //   icon: getIcon(fileTextFill)
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: getIcon(lockFill)
  // },
  // {
  //   title: 'register',
  //   path: '/register',
  //   icon: getIcon(personAddFill)
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: getIcon(alertTriangleFill)
  // }
];

export default sidebarConfig;
